import { gql } from '@apollo/client';

export const EVENT_FRAGMENT = gql`
  fragment eventFields on Event {
    id
    alarm
    comments
    creator {
      id
    }
    date
    daysOfRepeat
    done
    duration
    endOfRepeatDate
    ignoreDate
    isAllDay
    name
    occurrence
    originalEvent {
      id
    }
    recurrence
    type
    untilDate
  }
`;

export const TIMESLOT_FRAGMENT = gql`
  fragment timeslotFields on Timeslot {
    date
    duration
  }
`;